import applyArpavConfig from '@arpav/config/arpavConfig';

import '@plone/volto/config';

export default function applyConfig(config) {
  return applyArpavConfig(config);
}
